import { DealComment } from '../pages/DealFlow2/data-models/comment.data-model';
import { CustomDataType } from './company.data-model';

export interface IDealDataModel {
  id: number;
  companyId: number;
  customData?: Record<number, CustomDataType> | null;
  source: string;
  sourceTypeId: number;
  internalSourceId: number;
  description: string;
  roundId: number | null;
  dealTypeId: number;
  raiseAmount: number;
  gcAmountMin: number;
  gcAmountMax: number;
  passComments?: string | null;
  trackComments?: string | null;
  totalPic: number;
  nda: boolean;
  tsSigned: boolean;
  priority: number;
  stageId: number;
  stageUpdateDate: string;
  snoozeDate: string | null;
  createdBy: null | string;
  updatedBy: null | string;
  createdById: number;
  updatedById: null;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: null;
  comments: DealComment[];
  history: IDealHistoryDataModel[];
  stageComments?: string | null;
  todoList: string[] | null;
  dealLeadId: number | null;
  dealTeamIds: number[] | null;
  weeksOnList: number | null;
  internalSourceIds?: number[];
  sourceCompany?: string;
  fundId?: number | null;
  labels: string[] | null;
  fundIds?: number[];
}

export interface IDealHistoryDataModel {
  id: number;
  createdBy: string;
  updatedBy: null;
  createdAt: string;
  updatedAt: string;
  dealId: number;
  stageId: number;
  comment: string;
}

export function createDealHistoryDataModel(overrides: Partial<IDealHistoryDataModel> = {}) {
  return {
    id: 0,
    createdBy: '',
    updatedBy: null,
    createdAt: '',
    updatedAt: '',
    dealId: 0,
    stageId: 0,
    comment: '',
    ...overrides,
  };
}

export const createDealDataModel = (overrides: Partial<IDealDataModel> = {}): IDealDataModel => ({
  id: 0,
  companyId: 0,
  customData: {},
  source: '',
  sourceTypeId: 0,
  internalSourceId: 0,
  description: '',
  roundId: null,
  dealTypeId: 0,
  raiseAmount: 0,
  gcAmountMin: 0,
  gcAmountMax: 0,
  passComments: null,
  totalPic: 0,
  nda: false,
  tsSigned: false,
  priority: 0,
  stageId: 0,
  stageUpdateDate: '',
  snoozeDate: null,
  createdBy: '',
  updatedBy: null,
  createdById: 0,
  updatedById: null,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  comments: [],
  history: [],
  stageComments: undefined,
  todoList: null,
  dealLeadId: null,
  dealTeamIds: null,
  weeksOnList: null,
  internalSourceIds: undefined,
  sourceCompany: undefined,
  fundId: null,
  labels: null,
  fundIds: undefined,
  ...overrides,
});
